import { render, staticRenderFns } from "./ScaleMarkX.vue?vue&type=template&id=12d3ef16&scoped=true"
import script from "./ScaleMarkX.vue?vue&type=script&lang=js"
export * from "./ScaleMarkX.vue?vue&type=script&lang=js"
import style0 from "./ScaleMarkX.vue?vue&type=style&index=0&id=12d3ef16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3ef16",
  null
  
)

export default component.exports